import { useIsSupportProduct, useIsSupportVoucher } from 'hooks/business/chat/useChatSide';
import { isTiKTokUpperCase } from 'lib/utils/isTikTok';
import { useMemo } from 'react';
import {
  supportSendImagePlatforms,
  supportSendStickerPlatforms,
  supportSendVideoPlatforms,
} from 'services/config/platform';

interface UseMessageEditorToolbarFeaturesParams {
  channel: Conversation.Conversation['channel'];
  followerFlag: Conversation.Conversation['followerFlag'];
}

export function useMessageEditorToolbarFeatures(params: UseMessageEditorToolbarFeaturesParams) {
  const { channel, followerFlag } = params;
  const isSupportProduct = useIsSupportProduct(channel);
  const isSupportVoucher = useIsSupportVoucher(channel);

  return useMemo(
    () => ({
      showAttachmentUpload: channel === 'MERCADO',
      showPhrasePicker: channel !== 'WA_BIZ',
      showStickerPicker: supportSendStickerPlatforms.includes(channel),
      showVideoUpload: supportSendVideoPlatforms.includes(channel),
      showImageUpload: supportSendImagePlatforms.includes(channel),
      showLazadaFollow: channel === 'LAZADA' && !followerFlag,
      showShopeeFollow: channel === 'SHOPEE' || isTiKTokUpperCase(channel),
      showWaMsgTemplate: channel === 'WA_BIZ',
      showProductPicker: isSupportProduct,
      showCouponPicker: isSupportVoucher,
    }),
    [channel, followerFlag, isSupportProduct, isSupportVoucher],
  );
}
